import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const SHARE_ME_KEY = ["share", "me"];

export const shareApi = {
  getMe: () => api.get("/share/me").then((r) => r.data),
  checkAha: (trigger) =>
    api.post("/share/check-aha", { trigger }).then((r) => r.data),
  claim: () => api.post("/share/claim").then((r) => r.data),
};

export function useShareMe(enabled = true) {
  return useQuery({
    queryKey: SHARE_ME_KEY,
    queryFn: shareApi.getMe,
    enabled,
    staleTime: 30_000,
  });
}

export function useClaimShareReward() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: shareApi.claim,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: SHARE_ME_KEY });
    },
  });
}

/** Best-effort clipboard copy with execCommand fallback. */
export async function copyToClipboard(text) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to legacy path
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "absolute";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
